import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PECriminalHistoriesCardActions = {
  initPeCriminalHistoriesCard: ({ commit }, index) => {
    commit('setPeCriminalHistoriesCardLock', { index, lock: true })
  },
  peCriminalHistoriesCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post('/party_characteristics', {
        criminal_histories: {
          party_id: party.id,
          incident_date: section.incident_date,
          incident_date_format: section.incident_date_format,
          incident_date_uncertain: section.incident_date_uncertain,
          incident_location: section.incident_location,
          notes: section.notes,
        },
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeCriminalHistoriesCardLock', { index, lock: true })
        commit('pePatchParty', {
          criminal_histories: updatedParty.criminal_histories || [],
        })
      }).
      catch(handleError)
  },
  peCriminalHistoriesCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/criminal_histories/${section.id}`).
      then(({ data }) => {
        commit('setPeCriminalHistoriesCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'criminal_histories',
          value: data,
        })
      }).
      catch(handleError)
  },
  peCriminalHistoriesCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        criminal_histories: {
          party_id: party.id,
          incident_date: section.incident_date,
          incident_date_format: section.incident_date_format,
          incident_date_uncertain: section.incident_date_uncertain,
          incident_location: section.incident_location,
          notes: section.notes,
        },
        id,
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeCriminalHistoriesCardLock', { index, lock: true })
        commit('pePatchParty', {
          criminal_histories: updatedParty.criminal_histories || [],
        })
      }).
      catch(handleError)
  },
  peCriminalHistoriesCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          criminal_histories: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeCriminalHistoriesCardLock', { index, lock: true })
        commit('pePatchParty', {
          criminal_histories: updatedParty.criminal_histories || [],
        })
      }).
      catch(handleError)
  },
  peCriminalHistoriesCardAddSection: ({ commit }) => {
    commit('setPeCriminalHistoriesCardLock', { index: 'new', lock: false })
    commit('addPeCriminalHistoriesCardSection', {
      id: null,
      incident_date: null,
      incident_date_format: null,
      incident_date_uncertain: null,
      incident_location: null,
      notes: null,
    })
  },
}

export const PECriminalHistoriesCardMutations = {
  setPeCriminalHistoriesCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.CriminalHistoriesCard) {
      Vue.set(state.partyEdit.partySections, 'CriminalHistoriesCard', {})
    }
    Vue.set(state.partyEdit.partySections.CriminalHistoriesCard, index, lock)
  },
  addPeCriminalHistoriesCardSection: (state, section) => {
    state.partyEdit.party.criminal_histories.push(section)
  },
  peCriminalHistoriesCardCreateUndo: state => state.partyEdit.party.criminal_histories.pop(),
}

export const PECriminalHistoriesCardGetters = {
  peCriminalHistoriesCardLock: state => index => state.partyEdit.partySections.CriminalHistoriesCard[index],
  peCriminalHistoriesCardHasNewSection: (_, getters) => !!getters.
    peParty.
    criminal_histories?.
    find(language => language.id === null),
}
